// Imports comuns do Vue
import Vue from 'ninenine-white-label/Vue';
import App from './App.vue';
import store from './store';
import router from './router';
import './registerServiceWorker';
import SvgIcon from 'vue-svgicon';
import TnsSlider from 'ninenine-white-label/plugins/TnsSlider';
// import GLightbox from 'ninenine-white-label/plugins/GLightbox';
import SocialAuth from 'ninenine-white-label/plugins/SocialAuth';
import { Card, Button, Collapse, Tabs, Modal, Nav } from 'bootstrap-vue/es/components';
import { Scrollspy, Tooltip } from 'bootstrap-vue/es/directives';
import VueSweetalert2 from 'vue-sweetalert2';
import VueTheMask from 'vue-the-mask';
import Selectize from 'vue2-selectize';
import VueMoment from 'vue-moment';
import VueCroppie from 'vue-croppie';
import 'croppie/croppie.css';
// import { VLazyImagePlugin } from "v-lazy-image";
import "vue-material-design-icons/styles.css";
import VueGtag from "vue-gtag";


Vue.prototype.socialIds = {
  facebook: process.env.NODE_ENV == "development" ? "" : "",
  linkedin: process.env.NODE_ENV == "development" ? "" : ""
};

Vue.use(SvgIcon, {
  tagName: 'svgicon'
});

Vue.use(TnsSlider);
// Vue.use(GLightbox);

Vue.use(SocialAuth, {
  facebook: Vue.prototype.socialIds.facebook
});

Vue.use(Card);
Vue.use(Button);
Vue.use(Collapse);
Vue.use(Tabs);
Vue.use(Modal);
Vue.use(Nav);
Vue.use(Scrollspy);
Vue.use(Tooltip);
Vue.use(VueSweetalert2);
Vue.use(VueTheMask);
Vue.use(VueMoment);
Vue.use(VueCroppie);
Vue.component('selectize', Selectize);
// Vue.use(VLazyImagePlugin);
Vue.use(
  VueGtag,
  {
    config: {
      // id: "G-MKXQ7HF2N2",
    },
    includes: [
      { id: 'G-P6LCYDFPYC' }, // ninenine-ga
    ]
  },
  router
);

// Funcao auxiliar
Vue.prototype.delay = function (time) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(true)
    }, time)
  })
}

Vue.prototype.removeAutoFillSelectize = function () {
  Array.from(document.querySelectorAll('input')).map(element => {
    element.setAttribute('autocomplete', 'no')
  })
}

Vue.prototype.goToInvalidField = function (context) {
  setTimeout(() => {
    const element = context || document;
    Array.from(element.querySelectorAll(".is-invalid")).some(field => {
      field.querySelector('input').focus();
      return field;
    });
  }, 400)
}

Vue.prototype.dateRange = function (dateFrom, dateTo) {
  let a = Vue.prototype.$moment(dateTo);
  let b = Vue.prototype.$moment(dateFrom);
  let message = '';

  let years = a.diff(b, 'year');
  b.add(years, 'years');

  let months = a.diff(b, 'months');
  b.add(months, 'months');

  if (years > 0) message += years + ' anos '
  if (months > 0) message += months + ' meses '

  return message
}

Vue.config.productionTip = false;
Vue.prototype.$EventBus = new Vue();

new Vue({
  router,
  store,
  render: h => h(App),
  beforeCreate(){
    var lang = localStorage.getItem('lang')

    if (!lang) {
      localStorage.setItem('lang', 'pt')
      lang = localStorage.getItem('lang')
    }

    if(lang == 'pt'){
      this.$store.commit("CHANGE_TKN", this.$store.state.tkn1);
    } else {
      this.$store.commit("CHANGE_TKN", this.$store.state.tkn2);
    }
  }
}).$mount('#app');